export const getMaintenanceMessage = (state) => state.maintenanceMessage.message;
